import OrderInspection from './OrderInspection';

export default OrderInspection;
